import { render, staticRenderFns } from "./MyPostulationDetail.vue?vue&type=template&id=3b05577c&scoped=true"
import script from "./MyPostulationDetail.vue?vue&type=script&lang=ts"
export * from "./MyPostulationDetail.vue?vue&type=script&lang=ts"
import style0 from "./MyPostulationDetail.vue?vue&type=style&index=0&id=3b05577c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05577c",
  null
  
)

export default component.exports